/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.26.0
 * @since 1.25.1
 */

import moment from 'moment';

import { EFormatData } from '../PageDashboard/types/widgetTypes';
import { ICreateExternalNewsForm, ICreateInternalNewsForm } from './types';

export enum ECreateNewsTypes {
    INTERNAL = 'INTERNAL',
    EXTERNAL = 'EXTERNAL',
}

export enum ENewsFormCreationFields {
    TITLE = 'title',
    LINK = 'link',
    MARKDOWN = 'markdown',
    IMAGES = 'images',
    PUBLISH_FROM = 'publishFrom',
    PUBLISH_TO = 'publishTo',
    REPEAT = 'REPEAT',
    USER_FILE = 'USER_FILE',
}

export enum ERecipientTypes {
    ALL = 'ALL',
    INN = 'INN',
    ACCOUNT = 'ACCOUNT',
}

export const VALID_EXTENSIONS = ['xlsx'];

export const MAX_TITLE_LENGTH = 500;
export const MAX_LINK_LENGTH = 500;

export const MAX_IMAGES = 5;

export const DEFAULT_RECIPIENTS_FILE_NAME = 'recipients.xlsx';

export const TODAY_FULL_DATE = moment().format(EFormatData.ReverseData);

export const defaultCreateExternalNewsFormValues: ICreateExternalNewsForm = {
    [ENewsFormCreationFields.TITLE]: '',
    [ENewsFormCreationFields.LINK]: '',
    [ENewsFormCreationFields.PUBLISH_FROM]: TODAY_FULL_DATE,
    [ENewsFormCreationFields.PUBLISH_TO]: '',
};

export const defaultCreateInternalNewsFormValues: ICreateInternalNewsForm = {
    [ENewsFormCreationFields.TITLE]: '',
    [ENewsFormCreationFields.MARKDOWN]: '',
    [ENewsFormCreationFields.IMAGES]: [],
    [ENewsFormCreationFields.PUBLISH_FROM]: TODAY_FULL_DATE,
    [ENewsFormCreationFields.PUBLISH_TO]: '',
    [ENewsFormCreationFields.REPEAT]: 0,
};
